export const BACKSPACE_KEY = 8;
export const DELETE_KEY = 46;
export const ENTER_KEY = 13;
